import type { ReportDefinitionTenant } from './api';

/**
 * A busca de cliente na lista já carregada: por pedaço do nome, sem acento e sem caixa.
 * Mostra uma página por vez e revela a próxima quando a pessoa rola até o fim.
 */
export class TenantSearch {
  private static readonly PAGE = 20;

  private typed = $state('');
  private shown = $state(TenantSearch.PAGE);

  constructor(private readonly tenants: () => ReportDefinitionTenant[]) {}

  get term(): string {
    return this.typed;
  }

  get isSearching(): boolean {
    return !!this.typed.trim();
  }

  get hasNoMatch(): boolean {
    return this.isSearching && this.matching().length === 0;
  }

  get hasMore(): boolean {
    return this.matching().length > this.shown;
  }

  results(): ReportDefinitionTenant[] {
    return this.matching().slice(0, this.shown);
  }

  /** Termo novo volta à primeira página: a lista anterior podia estar rolada até o fim. */
  searchFor(term: string): void {
    this.typed = term;
    this.shown = TenantSearch.PAGE;
  }

  showMore(): void {
    this.shown += TenantSearch.PAGE;
  }

  private matching(): ReportDefinitionTenant[] {
    const term = TenantSearch.folded(this.typed.trim());
    return this.tenants().filter((tenant) => TenantSearch.folded(tenant.name).includes(term));
  }

  private static folded(text: string): string {
    return text.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
  }
}
